import { FontEnum } from '../../../SharedComponents/utils/enums/FontEnum';

const PlaceholderImage = require('../../../SharedComponents/assets/images/placeholders/no-image-placeholder.png');


const PartOfferPartRequestInfoDiv = ({
    fetchedPartOffer
}) => {
    const getRequestTitle = () => {
        return `Zahtev: ${fetchedPartOffer.PartRequest.title}`;
    };

    const partDescription = fetchedPartOffer.PartRequest.description;

    return (
        <div style={styles.selectedItemContainer}>
            <div style={styles.imageComponent}>
                <img
                    src={PlaceholderImage}
                    style={styles.carImage}
                />
            </div>
            <div>
                <p style={styles.carNameText}>
                    {getRequestTitle()}
                </p>

                {partDescription && (
                    <p style={{ ...styles.carDescriptionText, overflowWrap: 'break-word' }}>
                        {partDescription}
                    </p>
                )}
            </div>
        </div>
    );
};

export default PartOfferPartRequestInfoDiv;


const styles = {
    selectedItemContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        border: "1px solid #0000003b",
        borderRadius: 2,
        paddingInline: 12,
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: "#F3F4F6",
    },
    imageComponent: {
        display: 'flex'
    },
    carImage: {
        width: "48px",
        height: "48px",
        border: "1px solid #0000003b",
        borderRadius: 8,
        objectFit: "cover"
    },
    carNameText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 600,
        color: "#000000"
    },
    carDescriptionText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de",
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
    },
};